import {combineReducers} from 'redux';

import authorizationReducer from './authorizationReducer';
import translationReducer from './translationReducer';
import supporterListReducer from './supporterListReducer';
import supporterDetailsReducer from './supporterDetailsReducer';
import supporterProjectReducer from './supporterProjectReducer';
import supporterEmergencyContactReducer from './supporterEmergencyContactReducer';
import supporterCommentsReducer from './supporterCommentsReducer';
import queueListReducer from './queueListReducer';
import userReducer from './userReducer';
import overviewReducer from './overviewReducer';
import scheduleReducer from './scheduleReducer';
import addLocationReducer from './addLocationReducer';
import appReducer from './appReducer';
import cashRegisterReducer from './cashRegisterReducer';
import tabletReducer from './tabletReducer';
import projectReducer from './projectReducer';
import logbookReducer from "./logbookReducer";
import printerReducer from "./printerReducer";
import scopeReducer from "./scopeReducer";
import companyReducer from "./companyReducer";

const fusionSupporterBackendApp = combineReducers({
    authorization: authorizationReducer,
    translation: translationReducer,
    supporterList: supporterListReducer,
    supporterDetails: supporterDetailsReducer,
    supporterProject: supporterProjectReducer,
    supporterEmergencyContact: supporterEmergencyContactReducer,
    supporterComments: supporterCommentsReducer,
    queueList: queueListReducer,
    user: userReducer,
    overview: overviewReducer,
    schedule: scheduleReducer,
    addLocation: addLocationReducer,
    app: appReducer,
    cashRegister: cashRegisterReducer,
    tablet: tabletReducer,
    project: projectReducer,
    logbook: logbookReducer,
    printer: printerReducer,
    scope: scopeReducer,
    company: companyReducer
});

export default function (state, action){
    return fusionSupporterBackendApp(state, action);
}
